<template>
  <div class="dialog-scroll">
    <el-dialog
      :visible.sync="dialogVisible"
      :before-close="handleDialogClose"
      @close="resetForms"
      class="search-popup">
      <div class="title">{{ $t("title.popup.system.building.search") }}</div>
      <!-- 検索エリア START -->

      <el-form @submit.native.prevent :model="query" :rules="rules" ref="searchBuildingForm">
        <el-row :gutter="16">
          <el-col class="col">
            <el-form-item prop="buildingExId" class="input_item">
              <el-input
                class="input-class"
                maxlength="20"
                :placeholder="$t('label.common.buildingIdPlaceHolder')"
                v-model="query.buildingExId">
              </el-input>
            </el-form-item>
            <el-form-item prop="buildingName" class="input_item">
              <el-input
                class="input-class"
                maxlength="50"
                :placeholder="$t('label.common.buildingNamePlaceHolder')"
                v-model="query.buildingName">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div class="form-group">
              <narrow-down @click="searchBuilding">
                {{ $t("button.common.narrow") }}
              </narrow-down>
              <cancel-narrow-down @click="clearSearchParams" class="margin-left-8 link-primary">
                {{ $t("button.common.cancelNarrow") }}
              </cancel-narrow-down>
            </div>
          </el-col>
        </el-row>
      </el-form>

      <!-- 検索エリア END -->
      <!-- 检索結果 START -->
      <el-row v-show="isshow" class="search-common">
        <label class="font-size-16 lable-right-16">{{ $t("label.common.count") }}</label>
        <el-select @change="changePageSize" class="page-select" v-model="query.pageSize">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-row>

      <div id="popup-building-search-result" v-show="isshow" class="master-table-type">
        <el-table :data="searchResult.body">
          <el-table-column
            class="font"
            class-name="col-3"
            prop="ownerExId"
            :label="$t('label.popup.system.owner.label.ownerExId')"
          />
          <el-table-column
            class-name="col-4"
            prop="ownerName"
            :label="$t('label.popup.system.owner.label.ownerName')"
          />
          <el-table-column
            class-name="col-3"
            prop="buildingExId"
            :label="$t('label.popup.system.building.label.buildingExId')"
          />
          <el-table-column
            class-name="col-3"
            prop="buildingName"
            :label="$t('label.popup.system.building.label.buildingName')"
          />
          <el-table-column
            class-name="col-5"
            prop="postCodeAddress"
            :label="$t('label.popup.system.building.label.address')"
          />
          <el-table-column class-name="col-2">
            <div slot-scope="scope" class="detail-button with-100">
              <sp-smart-button @click="selectBuilding(scope.row)" class="detailed-but with-100">
                {{ $t("button.common.select") }}
              </sp-smart-button>
            </div>
          </el-table-column>
        </el-table>
      </div>
      <!-- 检索結果 END -->
      <!-- 分页 START -->
      <pagination
        class="m-top-5"
        v-show="searchResult.body.length > 0"
        :page-size="query.pageSize"
        :page-number="searchResult.pageNumber"
        :totalPage="searchResult.totalPage"
        :totalCount="searchResult.totalCount"
        @on-paging="handlePageChange"
      >
      </pagination>
      <!-- 分页 END -->
    </el-dialog>
  </div>
</template>

<script>
import popupRuleFactory from "@/rules/rule-popup-building";
import Pagination from "@/components/common/pagination/Pagination";
import SystemManageApi from "@/api/SystemManageApi";
import errorCodeMsg from "@/utils/error-code-msg"
import narrowDown from "@/components/common/generalButton/NarrowDown";
import cancelNarrowDown from "@/components/common/generalButton/CancelNarrowDown";
import SpSmartButton from "@/components/common/sp-smart-button"

const DEFAULT_PAGE_SIZE = 10;
const DEFAULT_PAGE_NUMBER = 1;
const EVENT_ON_SELECTED = "on-selected";
export default {
  name: "BuildingSearchPopup",
  props: {
    ownerIdParam: {
      type: String,
      default: null
    },
    buildingExIdParam: {
      type: String,
      default: null
    },
    buildingNameParam: {
      type: String,
      default: null
    },
    visible: Boolean,
    includeDeleteDataFlag: {
      type: Boolean,
      default: true
    },
    funcCode: {
      type: String,
      default: null
    }
  },
  data: function () {
    return {
      isshow: false,
      rules: popupRuleFactory.popupRules(this),
      query: {
        ownerId: this.ownerIdParam,
        ownerName: null,
        ownerExId: null,
        buildingId: null,
        buildingExId: this.buildingExIdParam,
        buildingName: this.buildingNameParam,
        pageSize: DEFAULT_PAGE_SIZE,
        pageNumber: DEFAULT_PAGE_NUMBER,
        funcCode: this.funcCode,
      },
      searchResult: {
        pageNumber: DEFAULT_PAGE_NUMBER,
        pageSize: DEFAULT_PAGE_SIZE,
        totalPage: 0,
        totalCount: 0,
        body: [],
      },
      isSearching: false,
      dialogVisible: this.visible,
      options: [
        {
          value: 10,
          label: "",
        },
        {
          value: 20,
          label: "",
        },
        {
          value: 50,
          label: "",
        },
      ],
    };
  },
  watch: {
    visible: function (value) {
      this.dialogVisible = value;
      this.query.ownerId = this.ownerIdParam;
      this.query.buildingExId = this.buildingExIdParam
      this.query.buildingName = this.buildingNameParam
    },
    // ownerIdParam: function (value) {
    //   this.query.ownerId = value;
    // },
    // buildingExIdParam: function (value) {
    //   this.query.buildingExId = value;
    // },
    // buildingNameParam: function (value) {
    //   this.query.buildingName = value;
    // }
  },
  methods: {
    resetForms() {
      this.$refs['searchBuildingForm'].resetFields()
    },
    changePageSize(){
      this.query.pageNumber = 1
      this.searchBuilding()
    },

    searchBuilding: function () {
      this.$refs["searchBuildingForm"].validate((valid) => {
        if (valid) {
          if (!this.isSearching) {
            this.isSearching = true;
            this.showTableLoadingAnim();
            if(this.includeDeleteDataFlag == null) {
              this.includeDeleteDataFlag = true
            }
            SystemManageApi.searchBuilding({
              ownerId: this.query.ownerId,
              ownerName: this.query.ownerName,
              ownerExId: this.query.ownerExId,
              buildingId: this.query.buildingId,
              buildingExId: this.query.buildingExId,
              buildingName: this.query.buildingName,
              includeDeleteDataFlag: this.includeDeleteDataFlag,
              pageSize: this.query.pageSize,
              pageNumber: this.query.pageNumber,
              funcCode: this.funcCode,
            })
            .catch((error) => {
              errorCodeMsg(error, this)
            })
            .then((resp) => {
              this.searchResult.totalPage = resp.data.body.totalPage;
              this.searchResult.totalCount = resp.data.body.totalCount;
              this.searchResult.pageNumber = resp.data.body.pageNumber;
              this.searchResult.body = [];
              for (let body of resp.data.body.body) {
                this.searchResult.body.push({
                  ownerId: body.ownerId,
                  ownerExId: body.ownerExId,
                  ownerName: body.ownerName,
                  buildingId: body.buildingId,
                  buildingExId: body.buildingExId,
                  buildingName: body.buildingName,
                  postCodeAddress: "〒"+ body.postCode + "　" + body.address,
                  postCode: body.postCode,
                  address: body.address,
                  aboveFloorCount: body.aboveFloorCount,
                  belowFloorCount: body.belowFloorCount,
                });
              }
            }).finally(() => {
              this.isSearching = false;
              this.hideTableLoadingAnim();
            });
          }
          this.isshow = true;
        } else {
          return false;
        }
      });
    },
    //显示表格加载动画
    showTableLoadingAnim() {
      if (this.tableLoadingAnim == null) {
        this.tableLoadingAnim = this.$loading({
          target: "#popup-building-search-result",
          background: "#ebebe6"
        });
      }
    },

    //隐藏表格加载动画
    hideTableLoadingAnim() {
      if (this.tableLoadingAnim != null) {
        this.tableLoadingAnim.close();
        this.tableLoadingAnim = null;
      }
    },

    selectBuilding(building) {
      this.dialogVisible = false;
      this.$emit(EVENT_ON_SELECTED, building);
      this.$emit("update:visible", false);
      this.clearSearchParams();
      this.isshow = false;
    },

    /**
     * 清空检索条件
     */
    clearSearchParams: function () {
      this.query.buildingExId = null;
      this.query.buildingName = null;
      this.query.pageSize = DEFAULT_PAGE_SIZE;
      this.query.pageNumber = DEFAULT_PAGE_NUMBER;
      this.searchResult.body = [];
      // this.$refs["searchBuildingForm"].resetFields();
      this.isshow = false;
    },

    handleDialogClose: function () {
      this.dialogVisible = false;
      this.$emit("update:visible", false);
      this.clearSearchParams();
      this.isshow = false;
    },

    handlePageChange: function (paging) {
      this.query.pageSize = paging.pageSize;
      this.query.pageNumber = paging.pageNumber;
      this.searchBuilding();
    }
  },
  components: {
    Pagination: Pagination,
    narrowDown,
    cancelNarrowDown,
    SpSmartButton,
  },
  mounted() {
    this.options[0].label = "10" + this.$t("label.common.case");
    this.options[1].label = "20" + this.$t("label.common.case");
    this.options[2].label = "50" + this.$t("label.common.case");
  },
};
</script>

<style scoped lang="scss">
.title {
  height: 60px;
  font-size: 24px;
  // color: #2699fb;
}
.el-select {
  line-height: 42px;
  width: 100px;
  font-size: 12px;
  height: 18px;
  border-radius: 8px;
  // overflow: hidden;
  color: #fff;

  ::v-deep.el-input__inner {
    border: none;
    // line-height: 24px;
    background-color: #f2f2ed;
    color: #525250;
    // font-size: 15px !important;
    // padding-left: 20px;
    box-shadow: -2px -2px 5px #fff,
      5px 5px 8px #e6e6e1;
  }
  ::placeholder {
    color: #525250;
  }
}

.search-popup {
  ::v-deep  .el-dialog {
    width: 1024px;
    height: 700px;
    background-color: #f2f2ed;
    border-radius: 3px !important;
    ::v-deep .el-dialog__header {
      height: 50px;
      ::v-deep .el-dialog__body {
        padding: 0px 24px 0px 19px;
      }
    }
  }
}

.left-input {
  margin-top: 13px;
  width: 200px;
}
.right-input {
  margin-top: 13px;
  margin-left: 16px;
  width: 200px;
  height: 22px;
}
.col {
  display: flex;
  flex-direction: row;
}
::v-deep .el-form-item__content {
  line-height: 22px;
}
.label {
  // color: #2699fb;
  font-size: 12px;
}

.btn-operate {
  margin: 0 5px 0 0;
}
::v-deep .detail-button{
  button {
    width: 100%;
  }
  .my-button{
    width: 134px;
  }
}
::v-deep .detail-button .my-button {
  margin-left: 5px;
}
::v-deep .detail-button .my-button {
  width: 100%;
  height: 40px;
  line-height: 0;
}

// add by mxq
.input_item {
  margin-right: 20px;
  ::v-deep.el-input .el-input__inner {
    width: 296px;
    height: 44px !important;
    border-radius: 8px !important;
    background: #f2f2ed;
    border: none;
    box-shadow: -2px -2px 5px #ffffff inset, -2px -2px 5px #ffffff inset,
      4px 5px 5px #e6e6e1 inset, 4px 5px 5px #e6e6e1 inset;
  }
}

::v-deep.el-icon-close {
  color: rgb(0, 0, 0);
}
.button_title {
  font-size: 12px;
  position: relative;
  bottom: 6px;
}
.search-common {
  display: block;
  //float: right;
  text-align: right;
  margin-top: 36px;
  margin-bottom: 20px;
}
</style>
